import { DateTime } from 'luxon';

export const isMaggiorenne = (dataNascita?: DateTime | null): boolean => {
  if (!dataNascita) {
    return false;
  }

  const oggi = DateTime.now();

  const eta = oggi.diff(dataNascita, 'years').years;

  return eta >= 18;
};
